var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgReferralBackLight = function SvgReferralBackLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "referral-back-light_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 307 326"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23",
    x1: 127.02,
    y1: 201.48,
    x2: 130.53,
    y2: 201.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4d4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f1c794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e9a756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_41",
    x1: -919.47,
    y1: 201.26,
    x2: -916.45,
    y2: 201.26,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fc1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52a0d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_41-2",
    x1: -916.33,
    y1: 197.61,
    x2: -911.56,
    y2: 197.61,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_26",
    x1: -928.43,
    y1: 191.15,
    x2: -911.93,
    y2: 201.73,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbefe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f8e2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0c28a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e69b3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_26-2",
    x1: -929.01,
    y1: 190.28,
    x2: -920.62,
    y2: 196.34,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_41-3",
    x1: -923.41,
    y1: 195.18,
    x2: -921.21,
    y2: 195.18,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-2",
    x1: 111.55,
    y1: 198.66,
    x2: 114.41,
    y2: 198.66,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-3",
    x1: 110.55,
    y1: 194.94,
    x2: 116.57,
    y2: 194.94,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4",
    x1: -908.46,
    y1: 236.66,
    x2: -901.88,
    y2: 236.66,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_40",
    x1: -914.69,
    y1: 254.65,
    x2: -904.53,
    y2: 253.58,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9c9c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_40-2",
    x1: -904.11,
    y1: 255.16,
    x2: -893.95,
    y2: 253.32,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-2",
    x1: -905.68,
    y1: 235.21,
    x2: -896.13,
    y2: 235.21,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_38",
    x1: -887.63,
    y1: 224.06,
    x2: -920.13,
    y2: 194.4,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66abd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#add8d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ceecd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-4",
    x1: 106.46,
    y1: 224.68,
    x2: 109.19,
    y2: 224.68,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-5",
    x1: 129.03,
    y1: 201.08,
    x2: 130.6,
    y2: 201.08,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-3",
    x1: 78.97,
    y1: 225.12,
    x2: 87.64,
    y2: 295.35,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient",
    x1: 74.07,
    y1: 226.2,
    x2: 92.97,
    y2: 226.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-4",
    x1: 66.42,
    y1: 219.11,
    x2: 77.31,
    y2: 217.18,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-5",
    x1: 100.4,
    y1: 218.88,
    x2: 89.6,
    y2: 218.11,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-6",
    x1: 83.15,
    y1: 202.92,
    x2: 84.3,
    y2: 232.69,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-2",
    x1: 75.16,
    y1: 243.74,
    x2: 103.31,
    y2: 275.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8cdb97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#97dda3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aee0bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-3",
    x1: 1069.14,
    y1: -346.76,
    x2: 1093.87,
    y2: -346.76,
    gradientTransform: "rotate(-80.87 931.642 525.47)",
    xlinkHref: "#referral-back-light_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-4",
    x1: 1066.86,
    y1: -352.01,
    x2: 1093.69,
    y2: -352.01,
    gradientTransform: "rotate(-80.87 931.642 525.47)",
    xlinkHref: "#referral-back-light_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-5",
    x1: 109.48,
    y1: 272.95,
    x2: 109.48,
    y2: 272.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90d4a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27ac4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-6",
    x1: 109.47,
    y1: 277.16,
    x2: 109.48,
    y2: 276.63,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-7",
    x1: 109.44,
    y1: 273.19,
    x2: 109.56,
    y2: 277.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94d6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b5e3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ceecd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-8",
    x1: 107.77,
    y1: 268.33,
    x2: 107.77,
    y2: 267.97,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-9",
    x1: 107.75,
    y1: 272.55,
    x2: 107.77,
    y2: 272.02,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-10",
    x1: 107.72,
    y1: 268.58,
    x2: 107.85,
    y2: 273.26,
    xlinkHref: "#referral-back-light_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-11",
    x1: 109.48,
    y1: 263.72,
    x2: 109.48,
    y2: 263.36,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-12",
    x1: 109.46,
    y1: 267.94,
    x2: 109.48,
    y2: 267.4,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-13",
    x1: 109.44,
    y1: 263.96,
    x2: 109.56,
    y2: 268.65,
    xlinkHref: "#referral-back-light_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-14",
    x1: 107.77,
    y1: 259.11,
    x2: 107.77,
    y2: 258.74,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-15",
    x1: 107.75,
    y1: 263.33,
    x2: 107.77,
    y2: 262.79,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-16",
    x1: 107.72,
    y1: 259.35,
    x2: 107.85,
    y2: 264.03,
    xlinkHref: "#referral-back-light_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-17",
    x1: 108.64,
    y1: 254.5,
    x2: 108.64,
    y2: 254.13,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-18",
    x1: 108.62,
    y1: 258.72,
    x2: 108.64,
    y2: 258.18,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-19",
    x1: 108.59,
    y1: 254.74,
    x2: 108.72,
    y2: 259.43,
    xlinkHref: "#referral-back-light_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_39",
    x1: 122.15,
    y1: 276.63,
    x2: 122.15,
    y2: 276.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#77b4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#55a1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1d82c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b81c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-20",
    x1: 109.9,
    y1: 267.4,
    x2: 136.14,
    y2: 267.4,
    xlinkHref: "#referral-back-light_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-21",
    x1: 122.23,
    y1: 279.39,
    x2: 123.81,
    y2: 255.41,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-22",
    x1: 128.55,
    y1: 275.04,
    x2: 117.27,
    y2: 259.45,
    xlinkHref: "#referral-back-light_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-23",
    x1: 118.33,
    y1: 267.4,
    x2: 127.56,
    y2: 267.4,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-24",
    x1: 112.46,
    y1: 276.27,
    x2: 133.59,
    y2: 276.27,
    xlinkHref: "#referral-back-light_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-6",
    x1: 229.55,
    y1: 217.97,
    x2: 231.62,
    y2: 217.97,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_38-2",
    x1: 240.27,
    y1: 239.28,
    x2: 222.02,
    y2: 217.79,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-7",
    x1: -516.18,
    y1: 255.17,
    x2: -503.83,
    y2: 255.17,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-8",
    x1: -519.42,
    y1: 255.17,
    x2: -512.52,
    y2: 255.17,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-7",
    x1: 228.06,
    y1: 215.47,
    x2: 232.64,
    y2: 215.47,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_38-3",
    x1: 231.92,
    y1: 229.84,
    x2: 214.41,
    y2: 219.54,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-8",
    x1: -515.85,
    y1: 275.56,
    x2: -513.79,
    y2: 275.56,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-9",
    x1: -505.86,
    y1: 275.56,
    x2: -503.81,
    y2: 275.56,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-25",
    x1: -523.54,
    y1: 218.85,
    x2: -521.88,
    y2: 218.85,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-26",
    x1: -522.62,
    y1: 218.81,
    x2: -521.99,
    y2: 218.81,
    gradientTransform: "translate(743.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1f3e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c9ead2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8bd29e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43b762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-10",
    x1: 219.89,
    y1: 221.59,
    x2: 223.17,
    y2: 221.59,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-27",
    x1: -522.61,
    y1: 219.64,
    x2: -521.59,
    y2: 219.64,
    xlinkHref: "#referral-back-light_svg__linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-11",
    x1: 220.53,
    y1: 221.09,
    x2: 224.35,
    y2: 221.09,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_38-4",
    x1: 236.43,
    y1: 230.38,
    x2: 221.12,
    y2: 215.96,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-28",
    x1: 601.27,
    y1: 222.66,
    x2: 601.33,
    y2: 222.66,
    gradientTransform: "matrix(-1 0 0 1 838.18 0)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-12",
    x1: 170.81,
    y1: 218.4,
    x2: 172.86,
    y2: 218.4,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-29",
    x1: 168.41,
    y1: 227.11,
    x2: 175.33,
    y2: 227.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a3cce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8dc0e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-30",
    x1: 174.92,
    y1: 234.06,
    x2: 178.01,
    y2: 234.06,
    xlinkHref: "#referral-back-light_svg__linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-9",
    x1: 168.41,
    y1: 255.06,
    x2: 180.57,
    y2: 255.06,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-31",
    x1: 170.37,
    y1: 230.71,
    x2: 176.81,
    y2: 230.71,
    xlinkHref: "#referral-back-light_svg__linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-10",
    x1: 165.22,
    y1: 255.06,
    x2: 172.01,
    y2: 255.06,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-13",
    x1: 169.34,
    y1: 215.94,
    x2: 173.85,
    y2: 215.94,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-32",
    x1: 161.88,
    y1: 225.32,
    x2: 169.51,
    y2: 225.32,
    xlinkHref: "#referral-back-light_svg__linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-14",
    x1: 168.73,
    y1: 275.15,
    x2: 170.76,
    y2: 275.15,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-15",
    x1: 178.57,
    y1: 275.15,
    x2: 180.6,
    y2: 275.15,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-33",
    x1: 161.16,
    y1: 219.27,
    x2: 162.79,
    y2: 219.27,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-16",
    x1: 162.06,
    y1: 219.23,
    x2: 162.68,
    y2: 219.23,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-17",
    x1: 161.29,
    y1: 220.1,
    x2: 163.07,
    y2: 220.1,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-18",
    x1: 162.07,
    y1: 220.04,
    x2: 163.07,
    y2: 220.04,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-19",
    x1: 169.4,
    y1: 240.68,
    x2: 171.6,
    y2: 240.68,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-20",
    x1: 204.1,
    y1: 215.75,
    x2: 205.62,
    y2: 215.75,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-21",
    x1: 204.86,
    y1: 217.74,
    x2: 206.98,
    y2: 217.74,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-11",
    x1: 742.63,
    y1: 257.51,
    x2: 748.83,
    y2: 257.51,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_26-3",
    x1: 742.72,
    y1: 229.31,
    x2: 764.28,
    y2: 229.31,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_4-12",
    x1: 742.72,
    y1: 257.51,
    x2: 755.78,
    y2: 257.51,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__New_Gradient_Swatch_copy_23-22",
    x1: 188.79,
    y1: 219.41,
    x2: 190.9,
    y2: 219.41,
    xlinkHref: "#referral-back-light_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-34",
    x1: 190.3,
    y1: 190.07,
    x2: 192.39,
    y2: 182.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aee0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#93d5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#72c989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#55be71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3eb55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2dae4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#20aa45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#19a73f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17a63d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-35",
    x1: -447.7,
    y1: 575.41,
    x2: -444.66,
    y2: 575.41,
    gradientTransform: "matrix(-.51 -.16 -.3 .95 135.26 -434.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5e9cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8dd3a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-36",
    x1: -447.75,
    y1: 577.94,
    x2: -447.74,
    y2: 572.74,
    gradientTransform: "matrix(0 -.54 -1 0 766.62 -54.32)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-37",
    x1: -447.71,
    y1: 580.12,
    x2: -447.7,
    y2: 573.36,
    gradientTransform: "matrix(-.51 -.16 -.3 .95 135.26 -434.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aee0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#96d7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59bf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17a63d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-38",
    x1: -448.22,
    y1: 575.44,
    x2: -447.22,
    y2: 575.44,
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-39",
    x1: 159.13,
    y1: 195.69,
    x2: 150.77,
    y2: 190.38,
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-40",
    x1: 154.89,
    y1: 195.13,
    x2: 154.38,
    y2: 196.21,
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-41",
    x1: 1511.12,
    y1: -932.91,
    x2: 1511.13,
    y2: -938.41,
    gradientTransform: "matrix(-1 0 0 1 1666.85 1129.12)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-42",
    x1: 161.7,
    y1: 197.36,
    x2: 153.44,
    y2: 192.05,
    gradientTransform: "rotate(44.47 155.784 193.56)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-43",
    x1: 593.13,
    y1: -874.02,
    x2: 594.19,
    y2: -874.02,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-44",
    x1: 171.65,
    y1: 176.06,
    x2: 166.47,
    y2: 172.77,
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-45",
    x1: 169.03,
    y1: 175.71,
    x2: 168.7,
    y2: 176.38,
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-46",
    x1: 1488.11,
    y1: -937.7,
    x2: 1488.11,
    y2: -941.11,
    gradientTransform: "matrix(-1 0 0 1 1657.63 1114.07)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-47",
    x1: 173.24,
    y1: 177.09,
    x2: 168.13,
    y2: 173.81,
    gradientTransform: "rotate(44.47 169.577 174.747)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-48",
    x1: 615.63,
    y1: -880.87,
    x2: 616.28,
    y2: -880.87,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-49",
    x1: 155,
    y1: 250.93,
    x2: 149.82,
    y2: 247.64,
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-50",
    x1: 152.37,
    y1: 250.58,
    x2: 152.05,
    y2: 251.25,
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-51",
    x1: 1552.44,
    y1: -895.93,
    x2: 1552.45,
    y2: -899.34,
    gradientTransform: "matrix(-.71 .7 .7 .71 1889.53 -197.38)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-52",
    x1: 156.59,
    y1: 251.96,
    x2: 151.47,
    y2: 248.68,
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-53",
    x1: 557.51,
    y1: -830.81,
    x2: 558.17,
    y2: -830.81,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-54",
    x1: 231.25,
    y1: 179.5,
    x2: 226.07,
    y2: 176.21,
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-55",
    x1: 228.62,
    y1: 179.15,
    x2: 228.3,
    y2: 179.82,
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-56",
    x1: 1447.99,
    y1: -893.49,
    x2: 1447.99,
    y2: -896.9,
    gradientTransform: "matrix(-1 0 0 1 1677.1 1073.32)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-57",
    x1: 232.83,
    y1: 180.53,
    x2: 227.72,
    y2: 177.25,
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-58",
    x1: 661.34,
    y1: -842.48,
    x2: 661.99,
    y2: -842.48,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-59",
    x1: 998.46,
    y1: 201.79,
    x2: 993.28,
    y2: 198.51,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-60",
    x1: 995.84,
    y1: 201.44,
    x2: 995.51,
    y2: 202.12,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-61",
    x1: 916.08,
    y1: -340.11,
    x2: 916.09,
    y2: -343.51,
    gradientTransform: "matrix(.71 .7 -.7 .71 -675.2 -197.38)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-62",
    x1: 1000.05,
    y1: 202.83,
    x2: 994.94,
    y2: 199.54,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-63",
    x1: 1262.98,
    y1: -365.91,
    x2: 1263.63,
    y2: -365.91,
    gradientTransform: "matrix(-.8 -.6 -.6 .8 1011.79 1249.11)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-64",
    x1: 1083.24,
    y1: 226.35,
    x2: 1075.78,
    y2: 221.61,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-65",
    x1: 1079.46,
    y1: 225.85,
    x2: 1079,
    y2: 226.81,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-66",
    x1: 873.01,
    y1: -263.52,
    x2: 873.02,
    y2: -268.42,
    gradientTransform: "rotate(90 258.34 -390.21)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-67",
    x1: 1085.53,
    y1: 227.84,
    x2: 1078.17,
    y2: 223.11,
    gradientTransform: "matrix(-.7 -.71 -.71 .7 1051 838.09)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back-light_svg__linear-gradient-68",
    x1: 1315.74,
    y1: -296.55,
    x2: 1316.68,
    y2: -296.55,
    gradientTransform: "matrix(-.8 -.6 -.6 .8 1011.79 1249.11)",
    xlinkHref: "#referral-back-light_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "referral-back-light_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h307v326H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".referral-back-light_svg__cls-3{opacity:.05}.referral-back-light_svg__cls-14{fill:#585f63}.referral-back-light_svg__cls-21{opacity:.1}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#referral-back-light_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "referral-back-light_svg__cls-3",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307 20s6 119.35-112.13 110.09-53.88 62.37-105.68 84.6-118.64-30.45-216.42-6.35 47 119.2-266.45 119.2H307z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307-1.16s6.4 127.57-119.85 117.67-57.58 66.66-112.95 90.42-126.81-32.56-231.32-6.79 50.24 127.4-284.77 127.4H307z",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127 200.86s2.27-1.78 2.94-1 .68 2.51.37 2.63-2 .8-2.08.86a18.7 18.7 0 01-1.23-2.49z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72 203.9l1.61-.52-.72-4.77-2.3.73z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61 198.7a2.5 2.5 0 003.34 1.37l1.24-.44a8.17 8.17 0 01-1.19-2.23 8.54 8.54 0 01-.59-2.43l-1.25.45a2.42 2.42 0 00-1.55 3.28z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_41-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.92 199.91s-.08.12-.54 0a12.59 12.59 0 00-9.08.11c-.3.11-.93-.89-1.42-2.23s-.66-2.51-.37-2.61a12.3 12.3 0 007-5.61c.1-.14.06 0 .13-.08-.51.66-.06 2.85.94 5.55 1.15 2.96 2.58 5.17 3.34 4.87z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.73 193.92c1.21 2.87 1.74 5.56 1.18 6s-2-1.53-3.18-4.41-1.74-5.55-1.19-6 1.98 1.54 3.19 4.41z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_26-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 194.65a1.55 1.55 0 01-.87 2h-.09c-.26-.51-.51-1.07-.74-1.65-.15-.41-.28-.79-.4-1.18 0 0 .07 0 .12-.05a1.53 1.53 0 011.98.88z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_41-3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-2)",
    d: "M114.41 200.82l-.04-2.96-2.82-1.74v5.09l2.86-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35 195.86s.32 2.4 2.25 2.4 2.88.16 2.88-1.76.48-3.85-.8-4.49-4.49-.8-4.33 1.92c0 0-.8-.64-.8.32s0 1.93.8 1.61z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M111.35 196.34s-5-3.69-1.6-6.26 4.33.49 7.37-1.6c0 0 2.89 2.41-.8 4 0 0-4.57-.56-4.25 2a1.34 1.34 0 00-1.28-.48c-.79.17.32 1.78.56 2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4)",
    d: "M119.32 252.96h-1.93l-4.65-21.3 3.55-11.3 2.19.13.84 32.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4 252.89l-.37 1.2a.66.66 0 00.63.87h5.57s.13-1-1.17-1.3a13.84 13.84 0 01-2.46-.77z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 252.89l-.38 1.2a.67.67 0 00.64.87h5.56s.13-1-1.16-1.3a13.51 13.51 0 01-2.46-.77z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_40-2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-2)",
    d: "M116.55 219.07l-8.78-1.55-.78 35.37h2.2l7.36-33.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 200.86l-4.9 7.23-2.88-6.74a3.65 3.65 0 00-2.69-2.15 28.74 28.74 0 00-3.62-.13 12.68 12.68 0 00-4.11.39 4.14 4.14 0 00-2.92 3.31c-.51 3-1.23 8.08-1 10.49a89 89 0 001.81 9.3h2.06l-.39-2.33 11.1.39-1.09-10 1.07 1.15a4.35 4.35 0 002 1.22c.84.16 1.58-.5 2.23-1.05l4.51-8.63z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 222.56a11 11 0 01.39 1.68c0 .38-.13.77-.39.38s-.13.91 0 1.55-1 1-1.94 0 0-3.61 0-3.61z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-21",
    d: "M118.48 210.55v-5.16l1.02 6.4-1.02-1.24zM108.41 220.36a58.6 58.6 0 01-.38-6.84 39.83 39.83 0 01.9-5.42l.52 12.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 202.45a1.08 1.08 0 01-1-.43c-.37-.55-.8-2-.3-2.14s.91-.43 1 .37",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4 200.58s.51-.52.74-.46.11.25.11.43-.68.55-.68.55z",
    fill: "#a0dab0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68 260.24C107 243 92 227.37 92 227.37H75S60.1 243 57.45 260.24a14.11 14.11 0 0013.93 16.24h24.38a14.09 14.09 0 0013.92-16.24z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 226.2a1.17 1.17 0 01-1.17 1.16h-16.6a1.17 1.17 0 010-2.33H91.8a1.17 1.17 0 011.2 1.17z",
    fill: "url(#referral-back-light_svg__linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.56 225h-1.33c-.78-2.34-6.43-6.86-7.6-8s3.54-3.39 4.68-4.2c.71-.51.23-1.63-.22-2.41 1.04 1.61 3.69 6.41 4.47 14.61z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8 225H91c.33-4.84 3.06-12 3.61-13.39a3.92 3.92 0 00.1 1.76c.56 1.8 3.66 1.07 4.47 3.68S93 220.77 91.8 225z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16 209.75a6.76 6.76 0 00-.57 1.86C94 213 91.3 220.19 91 225H76.56c-.78-8.23-3.43-13-4.47-14.64l-.12-.2-.29-.42a.2.2 0 01.08-.3c1.75-.74 15-8.61 23.31 0a.26.26 0 01.09.31z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.68 267.37V264a14.32 14.32 0 01-6.06-1.53l1.07-4.17a12.6 12.6 0 005.92 1.57c2 0 3.42-.78 3.42-2.21s-1.14-2.21-3.78-3.1c-3.81-1.28-6.41-3.06-6.41-6.52 0-3.13 2.21-5.59 6-6.34v-3.4h3.49v3.13a12.8 12.8 0 015.16 1.18l-1 4a11.8 11.8 0 00-5.13-1.21c-2.31 0-3.06 1-3.06 2 0 1.17 1.24 1.92 4.27 3.06 4.24 1.5 6 3.46 6 6.66s-2.24 5.88-6.34 6.59v3.64z",
    fill: "url(#referral-back-light_svg__linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36 252.13a1 1 0 01-.85.83c-6.3.87-7.43-4.47-8.74-10.65-.36-1.72-.74-3.49-1.24-5.38-2.22-8.26-10.61-9.9-10.69-9.92a1 1 0 01.36-2c.4.07 9.71 1.89 12.26 11.37.52 1.93.92 3.81 1.27 5.47 1.42 6.73 2.23 9.68 6.5 9.09a1 1 0 011.13.85.76.76 0 010 .34z",
    fill: "url(#referral-back-light_svg__linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.61 253.05a1.07 1.07 0 01-.11.33 1 1 0 01-1.36.39c-3.55-2-3.39-5-2-13.92 1.33-8.26-7.29-12.57-7.66-12.75a1 1 0 11.88-1.8c.1 0 10.32 5.13 8.76 14.87-1.51 9.39-1.14 10.7 1 11.85a1 1 0 01.49 1.03z",
    fill: "url(#referral-back-light_svg__linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15 273H96.81a2.35 2.35 0 011.44-.5h22.47a2.3 2.3 0 011.43.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15 276.63a2.31 2.31 0 01-1.43.49H98.25a2.29 2.29 0 01-1.43-.49z",
    fill: "url(#referral-back-light_svg__linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 274.82a2.29 2.29 0 01-.68 1.63l-.19.18H96.82a2.3 2.3 0 01-.2-3.44l.19-.18h25.34a2.33 2.33 0 01.85 1.81z",
    fill: "url(#referral-back-light_svg__linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44 268.4H95.1a2.3 2.3 0 011.43-.5H119a2.35 2.35 0 011.44.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43 272a2.24 2.24 0 01-1.43.5H96.53a2.24 2.24 0 01-1.43-.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 270.21a2.31 2.31 0 01-.68 1.63l-.2.17H95.1a2.31 2.31 0 01-.2-3.43l.2-.18h25.34a2.31 2.31 0 01.87 1.81z",
    fill: "url(#referral-back-light_svg__linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15 263.79H96.81a2.35 2.35 0 011.44-.5h22.46a2.31 2.31 0 011.44.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14 267.4a2.3 2.3 0 01-1.43.5H98.25a2.3 2.3 0 01-1.43-.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 265.6a2.27 2.27 0 01-.68 1.62 1.12 1.12 0 01-.2.18h-25.3a2.27 2.27 0 01-.88-1.8 2.31 2.31 0 01.68-1.64 1.54 1.54 0 01.19-.17h25.34a2.3 2.3 0 01.85 1.81z",
    fill: "url(#referral-back-light_svg__linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44 259.18H95.1a2.24 2.24 0 011.43-.5H119a2.29 2.29 0 011.44.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43 262.79a2.3 2.3 0 01-1.43.5H96.53a2.3 2.3 0 01-1.43-.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 261a2.27 2.27 0 01-.68 1.63 1.12 1.12 0 01-.2.18H95.1a2.3 2.3 0 01-.87-1.81 2.34 2.34 0 01.67-1.63l.2-.17h25.34a2.29 2.29 0 01.87 1.8z",
    fill: "url(#referral-back-light_svg__linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 254.57H96a2.3 2.3 0 011.43-.5h22.47a2.35 2.35 0 011.41.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3 258.18a2.3 2.3 0 01-1.43.5H97.4a2.32 2.32 0 01-1.43-.5z",
    fill: "url(#referral-back-light_svg__linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18 256.37a2.27 2.27 0 01-.68 1.63 1.12 1.12 0 01-.2.18H96a2.3 2.3 0 01-.87-1.81 2.34 2.34 0 01.67-1.63l.2-.17h25.34a2.29 2.29 0 01.84 1.8z",
    fill: "url(#referral-back-light_svg__linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_39)",
    d: "M122.15 276.66h-.01v-.07l.01.07z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.02,
    cy: 267.4,
    r: 13.12,
    fill: "url(#referral-back-light_svg__linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 255.39a12 12 0 00-10.57 17.74A12 12 0 10123 255.39z",
    fill: "url(#referral-back-light_svg__linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.02,
    cy: 267.4,
    r: 8.98,
    fill: "url(#referral-back-light_svg__linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.15 274.73l-.5-1.65a7.26 7.26 0 01-3.16.15l-.1-2.18a6.35 6.35 0 003.1-.11c1-.3 1.55-.88 1.34-1.58s-.88-.9-2.29-.95c-2-.06-3.56-.54-4.07-2.22-.46-1.52.25-3 2-4l-.5-1.65 1.7-.51.46 1.52a6.55 6.55 0 012.68-.19l.09 2.11a6 6 0 00-2.67.17c-1.12.34-1.34.93-1.19 1.42s.88.75 2.52.85c2.28.11 3.4.81 3.87 2.37s-.23 3.18-2.11 4.13l.53 1.76z",
    fill: "url(#referral-back-light_svg__linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59 273.12a12 12 0 01-21.13 0 13.11 13.11 0 0021.13 0z",
    opacity: 0.46,
    fill: "url(#referral-back-light_svg__linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M233.44 214.34a3.4 3.4 0 01-.08.57c0 1.37.95 1.46 1.3 1.13s.05 1.35-.52 4.52a5.93 5.93 0 00.58 3.69 5.38 5.38 0 00.62.95c.55.67 1.16 1 1.56.84 1-.4 0-3.29 0-3.41a1.15 1.15 0 001.63 0c.91-.77-.39-1.11-1.3-6.62s-4.58-3.51-4.58-3.51a2.28 2.28 0 01.79 1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.55 219.84c0 .41 1.45-1.26 1.84-1.51a3.82 3.82 0 00.11-.76c.06-.67.12-1.53.12-1.53a2.49 2.49 0 01-1.5 2.09.89.89 0 01-.38.06s0 .2-.06.48-.06.51-.08.76a4.09 4.09 0 00-.05.41z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.85 235.29h-9.74c0-2.2 1-4.2 1.28-6.62a5.36 5.36 0 00-.16-2.28 17.64 17.64 0 01-1-2.18 2.65 2.65 0 01.28-1.55 9.15 9.15 0 01.56-1.07 18.27 18.27 0 011.53-2.16v.41c0 .41 1.45-1.26 1.84-1.51a13.51 13.51 0 012.75 2.23 3 3 0 01.57.91 26.91 26.91 0 01.74 5c0 .09-.9 2.68-.4 3.8s2.02 3.49 1.75 5.02z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_38-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46 275h-1.81s-4.56-15.72-6-21c-.27-.94-.56-2-.86-3.13-.88-3.25-1.89-7.15-2.61-10.16v-.05-.06c-.46-1.93-.8-3.5-.93-4.35a6 6 0 01-.08-1h9.74c1.37 3.6.33 6.39-.72 17.23z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47 275h-1.8s-3.54-19.41-3.78-21 3.22-18.8 3.22-18.8a6 6 0 00.08 1c.13.85.47 2.42.93 4.35s0 0 0 .06v.05c.72 3 1.73 6.91 2.61 10.16 0 0-1.4 2.78-1.81 4s.55 20.18.55 20.18z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.06 214.66s.37 3.43 1.68 3.53a.89.89 0 00.38-.06 2.49 2.49 0 001.5-2.09c.19.12 1.21-.41.93-1.38s-.94-.46-1.18.45-.45.12-.71-.82-.36-.74-.82-1.29a.93.93 0 00-1.51.4 11.51 11.51 0 00-.27 1.26z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23 226.39s-3.89 3.83-4.91 3c-.5-.42-1.17-2.41-1.74-4.36l.51-.36 1.08-.63a11.5 11.5 0 001.12 2.22c.29.08 3.12-3.45 3.21-3.56a2.65 2.65 0 00-.28 1.55 17.64 17.64 0 001.01 2.14z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_38-3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M229.63 277.39h-.71l-.08-.62-1 .62s-2.33.08-2.49 0-.1-.61.18-.69 1.54-.32 1.72-.73h.14c.32.08 1.08.21 1.25-.44.1-.39.81-.12.81-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5 275.46s-.71-.27-.81.12c-.17.65-.93.52-1.25.44.34-.26.23-1 .23-1h1.8z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M239.62 277.39h-.71l-.09-.62-.94.62s-2.33.08-2.5 0-.1-.61.19-.69 1.54-.32 1.72-.73h.14c.31.08 1.08.21 1.25-.44.1-.39.8-.12.8-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.48 275.46s-.7-.27-.8.12c-.17.65-.94.52-1.25.44.34-.26.22-1 .22-1h1.81z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.41 220.43l-.21.1-.2-.53-.2-.46-.13-.28-.24-.56-.62-1.39.22-.09.71 1.61.66 1.48z",
    fill: "url(#referral-back-light_svg__linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.18 219a.41.41 0 01-.5-.25c-.07-.17.48-.23.55-.2a1.12 1.12 0 01.05.15v.08a.18.18 0 01-.1.22z",
    fill: "url(#referral-back-light_svg__linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.17 224l-1.08.63s-1-3-1.09-3.28a1.47 1.47 0 00-.52-.5 4 4 0 00-.55-1c-.16-.12.19-.94.44-1.23a.47.47 0 01.11-.1c.21-.07.08.51.13.66.08 0 .09.12.1.26v.2a.58.58 0 00.2.26 3.08 3.08 0 00.39.3l.36.24s.81 1.95 1.51 3.56z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 220.5l-.36-.24-.66-1.48a.41.41 0 00.5.25.18.18 0 00.11-.22 9.11 9.11 0 01.13 1.05 1.11 1.11 0 00.28.64z",
    fill: "url(#referral-back-light_svg__linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.35 222.69l-.7 1.31-1.56-3.25a6.43 6.43 0 01-.79-.58c-.23-.22 0-1 0-1.11s-.54-.42-.65-.49-.21-.27-.1-.37a9.43 9.43 0 011.87.86l.48 1.44z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.14 229.94c-2.52 0-6-4.95-6-4.95l.53-1 .7-1.31s3 3.62 4.15 3.8c.62.1 1.51-1.83 1.51-1.83 1.91-3.33 3.22-4 3.79-4.1a.61.61 0 01.53.16c2.65 2.55-2.74 9.29-5.21 9.23z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_38-4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M228.06 214.66a11.51 11.51 0 01.31-1.26.93.93 0 011.51-.4c.46.55.57.35.82 1.29s.47 1.72.71.82.9-1.39 1.18-.45-.74 1.5-.93 1.38-.06.86-.12 1.53a4.53 4.53 0 001.86-2.66 3.4 3.4 0 00.08-.57 2.28 2.28 0 00-.8-1.81 3.29 3.29 0 00-2.83-.75c-2.02.38-1.79 2.88-1.79 2.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86 222.69zm0 0z",
    fill: "url(#referral-back-light_svg__linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86 216.5s-.16 2.2-.24 2.25c-.38.25-1.85 1.89-1.81 1.49 0-.1 0-.24.05-.4s.06-.52.08-.75.06-.47.06-.47a.84.84 0 00.37-.06 2.46 2.46 0 001.49-2.06z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.85 232.39l-1.58 3.08h-3.86c0-2.17 1-4.14 1.26-6.53a5.18 5.18 0 00-.16-2.24 17.85 17.85 0 01-1-2.15 2.64 2.64 0 01.27-1.53 15.83 15.83 0 012.07-3.18c0 .16 0 .3-.05.4 0 .4 1.43-1.24 1.81-1.49a13.32 13.32 0 012.71 2.2c-4.69.19-1.47 11.44-1.47 11.44z",
    fill: "url(#referral-back-light_svg__linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 235.47h-3.09a26.18 26.18 0 001.67-2.82 18.59 18.59 0 011.42 2.82z",
    fill: "url(#referral-back-light_svg__linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.57 274.64h-1.78s-4.49-15.49-5.93-20.65c-.26-.92-.55-2-.85-3.08-.87-3.21-1.86-7-2.57-10v-.06-.05c-.46-1.9-.8-3.45-.93-4.29a7 7 0 01-.07-1H178c1.35 3.55.32 6.3-.72 17z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59 232.65a26.18 26.18 0 01-1.67 2.82c-1.46 2.29-3.32 5-3.32 5l-1.23-1.28 1.9-3.73 1.58-3.08s-3.22-11.25 1.48-11.44a3 3 0 01.57.9 28.25 28.25 0 01.73 5c.21 2.46.27 5.07-.04 5.81z",
    fill: "url(#referral-back-light_svg__linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73 274.64H169s-3.49-19.13-3.73-20.65 3.18-18.52 3.18-18.52a7 7 0 00.07 1c.13.84.47 2.39.93 4.29s0 0 0 .05v.06c.71 3 1.7 6.8 2.57 10 0 0-1.38 2.74-1.78 3.93s.49 19.84.49 19.84z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89 216.5a2.46 2.46 0 01-1.49 2.06.84.84 0 01-.37.06c-1.29-.1-1.66-3.48-1.66-3.48a11.1 11.1 0 01.31-1.24.91.91 0 011.48-.4c.46.54.57.35.82 1.27s.45 1.7.69.81.89-1.37 1.16-.44-.75 1.48-.94 1.36z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.51 226.7s-3.83 3.77-4.84 2.92-2.79-8.38-2.79-8.38l1.19-.35s2.27 5.56 2.56 5.64 3.08-3.4 3.16-3.51a2.64 2.64 0 00-.27 1.53 17.85 17.85 0 00.99 2.15z",
    fill: "url(#referral-back-light_svg__linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M170.89 277h-.7l-.08-.61-.93.61s-2.3.08-2.46 0-.1-.6.18-.68 1.52-.32 1.7-.72h.13c.31.08 1.07.21 1.24-.43.1-.39.79-.12.79-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.76 275.05s-.69-.27-.79.12c-.17.64-.93.51-1.24.43.34-.25.23-1 .23-1h1.77z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M180.73 277H180l-.08-.61-.92.61s-2.3.08-2.46 0-.1-.6.18-.68 1.52-.32 1.7-.72h.13c.32.08 1.07.21 1.24-.43.1-.39.79-.12.79-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6 275.05s-.69-.27-.79.12c-.17.64-.92.51-1.24.43.34-.25.23-1 .23-1h1.77z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79 220.83l-.21.09-.24-.56-.2-.45-.13-.27-.25-.55-.6-1.36.21-.1.7 1.59.65 1.46z",
    fill: "url(#referral-back-light_svg__linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.57 219.45a.41.41 0 01-.5-.25c-.07-.17.48-.23.54-.2l.06.15a.22.22 0 01-.1.3z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07 220.89l-1.19.35a4 4 0 00-.55-1c-.16-.11.19-.92.43-1.21a.24.24 0 01.12-.09c.2-.07.07.49.13.64.08 0 .09.12.1.26v.19a.51.51 0 00.2.26 3.86 3.86 0 00.38.3l.35.23z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07 220.89l-.35-.23-.65-1.46a.41.41 0 00.5.25.22.22 0 00.11-.22c0 .19.11.75.12 1a1 1 0 00.27.66z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6 240.48l-.2.55c-.19.56-.48 1.1-1 1.12s-.81-.78-.93-1.25v-.06-.05c-.08-.44 1-1.57 1-1.57z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M176.63 226.8a28.25 28.25 0 00-.73-5 3 3 0 00-.57-.9 13.32 13.32 0 00-2.71-2.2c.08-.05.24-2.25.24-2.25.19.12 1.19-.4.91-1.36s-.92-.45-1.16.44-.44.12-.69-.81-.36-.73-.82-1.27a.91.91 0 00-1.48.4 11.1 11.1 0 00-.31 1.24s.37 3.38 1.66 3.48c0 0 0 .2-.06.47l-2.09 1.21a6.52 6.52 0 01-.16-6.62s1.61-3.69 5.16-1.09c2.37 1.73 3 7.71 5.51 9.63 5.45 4.13-1.71 6.97-2.7 4.63zM196 276.76c0 .5.27.62.82.62a13.6 13.6 0 002.31 0c.28-.12 1-.52 1-.24s.54.37.82.24.27-2.1.27-2.1h-2s-.68.12-.81.62-2.41.37-2.41.86zM206.29 276.76c0 .5.28.62.82.62a13.71 13.71 0 002.32 0c.27-.12 1-.52 1-.24s.54.37.81.24.28-2.1.28-2.1h-2s-.68.12-.82.62-2.41.37-2.41.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.52 218a.4.4 0 00.34-.17c.22-.29.24-.85.34-1.05a1 1 0 00.08-.5.64.64 0 01.06-.18c.14-.28.55-1.37 0-1.37s-.14 1.5-.41 1.37-.14-1.78-.27-2.32-.55-.28-.55.54v.39c-.02.95-.02 3.29.41 3.29z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-20)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back-light_svg__cls-14",
    d: "M202.89 213.1c1 .68 1 .68.68 1s.53.66.53.66v-.39c0-.82.41-1.09.55-.54s0 2.18.27 2.32-.14-1.37.41-1.37.14 1.09 0 1.37a.64.64 0 00-.06.18s.33 1 .47 1.72H207s2.45-3.4 2-4.77-1.5-2.86-3.41-2.32-2.45.14-2.72-.13-.94 1.58.02 2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86 217.83a3.57 3.57 0 010 1.36 4.09 4.09 0 012.09-.27c-.13-.78 0-.92 0-.92h-1.23c-.14-.68-.47-1.72-.47-1.72a1 1 0 01-.08.5c-.1.2-.12.76-.34 1.05z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.29 249.43l2.19 11.19 1.91 14.66h2.09c.11-2.5-.55-14.66-.55-14.66.55-6.34.55-18.25.55-18.25s0-1-.08-2.63a70 70 0 00-6.11 9.69z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.85 221.34s5.19 10 7.15 10 5.41-3.75 5.5-3.84c0 .15-1.31 5.39-2.44 12.24h11.34c-.17-5.36-.62-17.14-1.4-18.39a6.83 6.83 0 00-2.85-2.39h-.18a4.09 4.09 0 00-2.09.27l-.44.21a7.52 7.52 0 00-2.42 1.26c-.53.64-5.11 5.91-5.11 5.91s-4.57-4.56-6-6.22z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_26-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34 257.87l.73 17.41h2.09s.54-15.94 1.45-19.23a35.88 35.88 0 012.68-6.62 70 70 0 016.11-9.69h-11.34a114.22 114.22 0 00-1.72 18.13z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_4-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.79 219.8c0 .43 1.06 1.54 1.06 1.54l1.05-1s-.11-1.17-.47-1.46-1-1.2-1.29-1.38.25.85.25 1.12-.55.76-.6 1.18z",
    fill: "url(#referral-back-light_svg__New_Gradient_Swatch_copy_23-22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.24 186.33c-.45 1.44-.47 2.73-.06 3.07l.12.06c.53.17 1.35-1 1.85-2.52s.47-3-.06-3.13h-.12c-.53.01-1.27 1.08-1.73 2.52z",
    fill: "url(#referral-back-light_svg__linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.63 186.15c-.49 1.56-.61 2.83.43 3.23l.24.08-.12-.06c-.41-.34-.39-1.63.06-3.07s1.2-2.51 1.73-2.54h.12l-.24-.08c-.85-.39-1.72.88-2.22 2.44z",
    fill: "url(#referral-back-light_svg__linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.22,
    cy: 186.64,
    rx: 2.5,
    ry: 0.82,
    transform: "rotate(-72.42 191.228 186.647)",
    fill: "url(#referral-back-light_svg__linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.68 186.47c-.27.85-.26 1.61 0 1.7s.74-.52 1-1.37.25-1.62 0-1.71-.68.53-1 1.38z",
    fill: "url(#referral-back-light_svg__linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.68 187.76l.13-.29a1.09 1.09 0 01.09-.71c.1-.26.2-.36.34-.35s.15 0 .19-.11a.3.3 0 000-.26.12.12 0 00-.14-.06l.11-.35a.16.16 0 01.15.06l.1-.24.07.1-.11.27a1.1 1.1 0 01-.09.69c-.11.28-.23.34-.35.32s-.13 0-.18.13a.3.3 0 000 .28.13.13 0 00.17.06l-.12.37a.15.15 0 01-.17-.07l-.11.27z",
    fill: "url(#referral-back-light_svg__linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.38 194.94c1.12 1.13 2.56 1.55 3.39 1a1.2 1.2 0 00.21-.17c.78-.76.42-2.38-.8-3.61s-2.82-1.63-3.6-.87l-.15.19c-.56.84-.17 2.31.95 3.46z",
    fill: "url(#referral-back-light_svg__linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 195.29c1.21 1.23 2.83 1.62 3.6.86l.36-.35a1.2 1.2 0 01-.21.17c-.83.52-2.27.1-3.39-1s-1.51-2.62-.95-3.43l.15-.19-.36.35c-.75.73-.4 2.35.8 3.59z",
    fill: "url(#referral-back-light_svg__linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.82,
    cy: 193.53,
    rx: 1.61,
    ry: 2.64,
    transform: "rotate(-44.47 155.819 193.529)",
    fill: "url(#referral-back-light_svg__linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.78,
    cy: 193.56,
    rx: 1.07,
    ry: 1.71,
    transform: "rotate(-44.47 155.78 193.555)",
    fill: "url(#referral-back-light_svg__linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74 194.57l-.22-.22a.5.5 0 01-.29.23l-.25-.32a.47.47 0 00.29-.22.26.26 0 000-.32c-.09-.09-.18-.08-.33 0a.46.46 0 01-.63-.07.77.77 0 01-.24-.73l-.22-.21.11-.19.21.2a.45.45 0 01.23-.2l.24.31a.44.44 0 00-.24.2.22.22 0 000 .29c.08.07.17.06.34 0a.45.45 0 01.62.1.76.76 0 01.25.76l.24.23z",
    fill: "url(#referral-back-light_svg__linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.71 175.59a1.87 1.87 0 002.1.64l.13-.1c.48-.47.26-1.48-.5-2.24s-1.75-1-2.23-.54l-.09.12c-.35.53-.12 1.41.59 2.12z",
    fill: "url(#referral-back-light_svg__linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48 175.81c.76.76 1.75 1 2.23.53l.23-.21-.13.1a1.87 1.87 0 01-2.1-.64c-.7-.71-.94-1.62-.59-2.12l.09-.12-.22.22c-.48.43-.26 1.43.49 2.24z",
    fill: "url(#referral-back-light_svg__linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.6,
    cy: 174.72,
    rx: 1,
    ry: 1.64,
    transform: "rotate(-44.47 169.601 174.725)",
    fill: "url(#referral-back-light_svg__linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.57,
    cy: 174.74,
    rx: 0.66,
    ry: 1.06,
    transform: "rotate(-44.47 169.58 174.744)",
    fill: "url(#referral-back-light_svg__linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.17 175.36l-.14-.13a.29.29 0 01-.18.14l-.15-.2a.36.36 0 00.18-.13.15.15 0 000-.2c0-.06-.11-.05-.2 0a.29.29 0 01-.39-.05.46.46 0 01-.15-.45l-.14-.13.07-.12.13.13a.29.29 0 01.15-.13l.14.2a.24.24 0 00-.15.12.14.14 0 000 .18h.21a.3.3 0 01.39.06.48.48 0 01.15.47l.15.15z",
    fill: "url(#referral-back-light_svg__linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.06 250.46a1.87 1.87 0 002.1.64l.13-.1c.47-.47.25-1.48-.5-2.24s-1.75-1-2.23-.54a.94.94 0 00-.09.12c-.35.5-.11 1.41.59 2.12z",
    fill: "url(#referral-back-light_svg__linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.83 250.68c.75.76 1.75 1 2.23.53l.23-.21-.13.1a1.87 1.87 0 01-2.1-.64c-.7-.71-.94-1.62-.59-2.12a.94.94 0 01.09-.12l-.22.22c-.48.47-.26 1.47.49 2.24z",
    fill: "url(#referral-back-light_svg__linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 250.29c.64.64 1.47.85 1.86.47s.2-1.22-.44-1.87-1.46-.85-1.85-.47-.2 1.22.43 1.87z",
    fill: "url(#referral-back-light_svg__linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45 250.07c.41.42 1 .55 1.21.29s.14-.8-.27-1.22-.95-.55-1.21-.29-.18.8.27 1.22z",
    fill: "url(#referral-back-light_svg__linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.52 250.24l-.14-.14a.29.29 0 01-.18.14l-.15-.2a.3.3 0 00.17-.13.15.15 0 000-.2c-.06-.06-.11-.05-.2 0a.28.28 0 01-.39 0 .49.49 0 01-.15-.46l-.14-.13.07-.11.13.12a.32.32 0 01.14-.13l.15.2a.24.24 0 00-.15.12.13.13 0 000 .18h.2a.3.3 0 01.39.06.49.49 0 01.15.48l.15.14z",
    fill: "url(#referral-back-light_svg__linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.3 179a1.88 1.88 0 002.1.64l.13-.1c.48-.47.26-1.48-.49-2.24s-1.75-1-2.23-.54l-.1.12a1.86 1.86 0 00.59 2.12z",
    fill: "url(#referral-back-light_svg__linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08 179.25c.75.76 1.75 1 2.23.53l.22-.21-.13.1a2.28 2.28 0 01-2.69-2.76l.1-.12-.23.22c-.48.47-.25 1.47.5 2.24z",
    fill: "url(#referral-back-light_svg__linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.19,
    cy: 178.16,
    rx: 1,
    ry: 1.64,
    transform: "rotate(-44.47 229.193 178.16)",
    fill: "url(#referral-back-light_svg__linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.69 178.64c.42.42 1 .55 1.22.29s.14-.8-.27-1.22-.95-.55-1.21-.29-.15.8.26 1.22z",
    fill: "url(#referral-back-light_svg__linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76 178.8l-.14-.13a.3.3 0 01-.17.14l-.16-.2a.29.29 0 00.18-.13.16.16 0 000-.2c-.06-.06-.12-.05-.2 0a.3.3 0 01-.4 0 .46.46 0 01-.14-.46l-.14-.13.06-.12.13.13a.29.29 0 01.15-.13l.15.2a.22.22 0 00-.15.12.13.13 0 000 .18c0 .05.11 0 .21 0a.3.3 0 01.39.06.49.49 0 01.15.48l.15.14z",
    fill: "url(#referral-back-light_svg__linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.8 201.33a1.87 1.87 0 01-2.1.64l-.13-.11c-.48-.47-.26-1.47.5-2.24s1.75-1 2.23-.53l.09.11a1.84 1.84 0 01-.59 2.13z",
    fill: "url(#referral-back-light_svg__linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 201.54c-.75.77-1.75 1-2.23.54l-.23-.22.13.11a1.87 1.87 0 002.1-.64 1.84 1.84 0 00.59-2.13l-.09-.11.22.22c.51.47.29 1.47-.49 2.23z",
    fill: "url(#referral-back-light_svg__linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63 201.15c-.64.65-1.47.86-1.86.47s-.2-1.22.43-1.86 1.47-.86 1.86-.47.2 1.22-.43 1.86z",
    fill: "url(#referral-back-light_svg__linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41 200.94c-.41.42-.95.55-1.22.29s-.14-.8.27-1.22 1-.55 1.22-.29.14.8-.27 1.22z",
    fill: "url(#referral-back-light_svg__linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.27 201l.15-.14a.49.49 0 01.16-.47.28.28 0 01.38-.07c.11.06.16.07.21 0a.15.15 0 000-.18.32.32 0 00-.15-.13l.14-.19a.32.32 0 01.15.12l.13-.12.07.12-.14.13a.46.46 0 01-.15.45.29.29 0 01-.39.05c-.09-.06-.14-.06-.2 0a.17.17 0 000 .2.33.33 0 00.18.14l-.15.2a.39.39 0 01-.18-.14l-.14.13z",
    fill: "url(#referral-back-light_svg__linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32 225.68c-1 1-2.29 1.38-3 .92l-.18-.15c-.69-.68-.37-2.12.71-3.23s2.52-1.44 3.21-.77a1.15 1.15 0 01.14.17c.47.73.12 2.04-.88 3.06z",
    fill: "url(#referral-back-light_svg__linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64 226c-1.08 1.1-2.52 1.45-3.21.77l-.32-.31.18.15c.74.46 2 .09 3-.92s1.35-2.33.85-3.06a1.15 1.15 0 00-.14-.17l.32.32c.68.66.4 2.11-.68 3.22z",
    fill: "url(#referral-back-light_svg__linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.04,
    cy: 224.42,
    rx: 2.36,
    ry: 1.43,
    transform: "rotate(-45.53 134.041 224.42)",
    fill: "url(#referral-back-light_svg__linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.07,
    cy: 224.45,
    rx: 1.53,
    ry: 0.96,
    transform: "rotate(-45.53 134.072 224.448)",
    fill: "url(#referral-back-light_svg__linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12 225.18l.21-.2a.69.69 0 01.22-.68.41.41 0 01.56-.09c.15.08.23.09.3 0a.19.19 0 000-.26.36.36 0 00-.21-.18l.21-.28a.38.38 0 01.21.18l.19-.18.1.17-.2.19a.67.67 0 01-.22.65.4.4 0 01-.56.06c-.13-.07-.21-.08-.29 0a.24.24 0 000 .29.42.42 0 00.26.19l-.22.29a.51.51 0 01-.26-.2l-.2.19z",
    fill: "url(#referral-back-light_svg__linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "referral-back-light_svg__cls-3",
    cx: 152.24,
    cy: 276.47,
    rx: 103.22,
    ry: 6.26
  }))));
};

export default SvgReferralBackLight;